import { render, staticRenderFns } from "./account_edit_m.vue?vue&type=template&id=d2278fc0&scoped=true&"
import script from "./account_edit_m.vue?vue&type=script&lang=js&"
export * from "./account_edit_m.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2278fc0",
  null
  
)

export default component.exports